import React, { memo } from "react";
import useStores, { observer } from "stores";
import { useDisLogoutInfo } from "hooks/services/common";
import { useUserInfo } from "hooks/common";
import { NavLink } from "react-router-dom";
import { SmileOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Typography } from "antd";

const LayoutHeader = () => {
	const userInfo = useUserInfo();
	const { authStore } = useStores();
	const { onLogout } = authStore;

	const { mutateAsync: disLogoutInfo } = useDisLogoutInfo({
		onSuccess: (data) => data.status === 200 && onLogout(),
	});

	const { Title } = Typography;

	return (
		<Layout.Header className="layout-page-header">
			<div className="actions">
				{/* <Button type="primary" onClick={toggle}>
					{collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
				</Button> */}
				<div className="logo">
					<NavLink to="/">
						<Title level={4} style={{ margin: 0, lineHeight: 1 }}>
							스마트오더
						</Title>
					</NavLink>
				</div>
			</div>
			<div style={{ marginRight: 20, gap: 15 }} className={"d-flex ai-center"}>
				<div className={"d-flex ai-center"}>
					<SmileOutlined style={{ color: "#666666" }} />
					<span style={{ margin: "5px" }}>
						{userInfo?.memberNm || ""}님 반갑습니다.
					</span>
				</div>
				<div
					className={"d-flex ai-center"}
					style={{ cursor: "pointer" }}
					onClick={() => {
						disLogoutInfo();
					}}
				>
					<LogoutOutlined style={{ color: "#666666" }} />
					<span style={{ margin: "5px" }}>로그아웃</span>
				</div>
			</div>
		</Layout.Header>
	);
};

export default memo(observer(LayoutHeader));
